import { Button, Collapse, Drawer } from "antd";

import { IoCloseCircleOutline } from "react-icons/io5";
import styles from "./ProductFilterDrawer.module.scss";
import { Checkbox } from "antd";

const Filter = ({ header, items, value, onChange }) => {
  return (
    <Collapse expandIconPosition="end" defaultActiveKey={["1"]} ghost>
      <Collapse.Panel header={header} key="1">
        <Checkbox.Group value={value} key={1} onChange={onChange} style={{ width: "100%" }}>
          {items.map((item, index) => {
            return (
              <div className={styles.checkbox_wrapper} key={index}>
                <Checkbox style={{ textTransform: "capitalize" }} value={`${item.label}/${item.value}`}>
                  {item.label}
                </Checkbox>
                <span>({item.amount} )</span>
              </div>
            );
          })}
        </Checkbox.Group>
      </Collapse.Panel>
    </Collapse>
  );
};

const ProductFilterDrawer = (props) => {
  return (
    <Drawer
      placement="right"
      onClose={() => props.setShowMobileDrawer(false)}
      open={props.showMobileDrawer}
      width={"100vw"}
      closable={false}
      bodyStyle={{
        marginBottom: "5rem",
        padding: 0,
      }}
    >
      <div className={styles.filter_drawer_body}>
        <div className={styles.filter_drawer_top}>
          <h5 className={styles.filter_drawer_reset} onClick={props.resetFilter}>
            Reset
          </h5>
          <h4 className={styles.filter_drawer_headline}>Filter</h4>
          <IoCloseCircleOutline onClick={() => props.setShowMobileDrawer(false)} size={22} />
        </div>
        <div className={styles.filter_drawer_collapse}>
          {/* Mobile Filter Area */}
          <Filter
            header="Discounts"
            onChange={(checkedValues) => {
              props.setDesktopFilters((prev) => ({
                ...prev,
                discounts_and_offer: checkedValues,
              }));
            }}
            value={props.desktopFilters.discounts_and_offer}
            items={[
              {
                label: "Offers & discounts",
                value: "offers_and_discounts",
                amount: props.desktopFilterUIStates?.discounts_and_offer_count,
              },
            ]}
          />

          <Filter
            header="Brands"
            onChange={(checkedValues) => {
              props.setDesktopFilters((prev) => ({
                ...prev,
                brands: checkedValues,
              }));
            }}
            value={props.desktopFilters.brands}
            items={props.desktopFilterUIStates?.brands.map((brand) => ({
              label: brand.brand__name,
              value: brand.brand__id,
              amount: brand.dcount,
            }))}
          />

          <div className={styles.filter_drawer_button}>
            <Button size="large" onClick={() => props.setShowMobileDrawer(false)} type="primary" block>
              Show{" "}
              <span
                style={{
                  fontSize: 17,
                  marginInline: 4,
                  fontWeight: 600,
                }}
              >
              </span>{" "}
              Products
            </Button>
          </div>
        </div>
      </div>
    </Drawer>
  )
}

export default ProductFilterDrawer;